export function LoadingScreen() {
  return (
    <div role="status" className="flex min-h-screen items-center justify-center text-muted-foreground">
      Chargement…
    </div>
  );
}
